import { cn } from '@utils/safeTs'
import React from 'react'

const FormInput = ({
  name = undefined,
  type = undefined,
  placeholder = undefined,
  disabled = false,
  value = undefined,
  onBlur = undefined,
  onChange = undefined,
  onKeyDown = undefined,
  defaultChecked = undefined,
  max = null,
  min = null,
  autoComplete = false,
  ariaLabel = undefined,
  id,
  className = undefined,
  readOnly = false,
}) => {
  return max || min ? (
    <input
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      onKeyDown={onKeyDown}
      className={cn("forminput formfield__input", className)}
      type={type ? type : 'text'}
      disabled={disabled}
      placeholder={placeholder}
      defaultChecked={defaultChecked}
      max={max}
      min={min}
      readOnly={readOnly}
      {...(!autoComplete ? { autoComplete: 'off' } : {})}
      id={id}
      aria-label={ariaLabel}
    />
  ) : (
    <input
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      onKeyDown={onKeyDown}
      className={cn("forminput formfield__input", className)}
      type={type ? type : 'text'}
      disabled={disabled}
      placeholder={placeholder}
      defaultChecked={defaultChecked}
      readOnly={readOnly}
      {...(!autoComplete ? { autoComplete: 'off' } : {})}
      id={id}
      aria-label={ariaLabel}
    />
  )
}

export default FormInput
